import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { roleHome } from "@/lib/constants";
import Shell from "@/components/Shell";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowRight, Headset } from "lucide-react";
import { TicketList } from "@/components/support/TicketList";
import { TicketThread } from "@/components/support/TicketThread";
import { NewTicketDialog } from "@/components/support/NewTicketDialog";
import { useTickets } from "@/components/support/useTickets";

export default function SupportPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { tickets, load } = useTickets();
  const [selected, setSelected] = useState(null);
  const ticket = tickets.find((t) => t.id === selected);

  return (
    <Shell title="خدمة العملاء" subtitle="افتح تذكرة وتابع ردود فريق الدعم في مكان واحد" icon={Headset}
      actions={
        <div className="flex gap-2">
          <Button variant="outline" className="rounded-full gap-2" onClick={() => navigate(roleHome(user.role))} data-testid="support-back-btn">
            <ArrowRight className="w-4 h-4" /> رجوع
          </Button>
          <NewTicketDialog onCreated={(t) => { load(); setSelected(t.id); }} />
        </div>
      }>
      <div className="grid lg:grid-cols-[340px_1fr] gap-5">
        <Card className={`overflow-hidden max-h-[640px] overflow-y-auto ${ticket ? "hidden lg:block" : ""}`}>
          <div className="px-4 py-3 border-b border-border font-semibold text-sm">تذاكري ({tickets.length})</div>
          <TicketList tickets={tickets} selectedId={selected} onSelect={setSelected} />
        </Card>
        <Card className={ticket ? "" : "hidden lg:block"}>
          {ticket && (
            <Button variant="ghost" size="sm" className="lg:hidden m-3 mb-0 gap-1" onClick={() => setSelected(null)} data-testid="ticket-mobile-back">
              <ArrowRight className="w-4 h-4" /> كل التذاكر
            </Button>
          )}
          <TicketThread ticket={ticket} meId={user.id} onChanged={load} />
        </Card>
      </div>
    </Shell>
  );
}
